// extracted by mini-css-extract-plugin
module.exports = {"expandable-container":"expandable-container__3Wa_9","expand-button-wrapper":"expand-button-wrapper__2of8R","expand-button":"expand-button__q4Sq9"};